import React, { useEffect } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import InboxIcon from '@material-ui/icons/MoveToInbox';
import MailIcon from '@material-ui/icons/Mail';
import CloseIcon from '@material-ui/icons/Close';

const useStyles = makeStyles({
	list: {
		width: 200
	},
	fullList: {
		width: 'auto',
	},
	menuDiv: {
		backgroundColor: '#192734',
		color: '#ffffff',
	},
});

type Anchor = 'top' | 'left' | 'bottom' | 'right';

interface Props {
	open?: boolean;
	// closeMenu: any;
}

export default function DrawerDriver(props: Props) {
	const classes = useStyles();
	const [state, setState] = React.useState({
		left: props.open,
	});
	useEffect(()=> {
		setState(state => ({
			left: props.open
		}))
	}, [props])
	const toggleDrawer = (anchor: Anchor, open: boolean) => (
		event: React.KeyboardEvent | React.MouseEvent
	) => {
		if (
			event.type === 'keydown' &&
			((event as React.KeyboardEvent).key === 'Tab' ||
				(event as React.KeyboardEvent).key === 'Shift')
		) {
			return;
		}

		setState({ ...state, [anchor]: open });
	};

	const list = (anchor: Anchor) => (
		<div
			className={clsx(classes.list, {
				[classes.fullList]: anchor === 'top' || anchor === 'bottom',
			})}
			role="presentation"
			onClick={toggleDrawer(anchor, false)}
			onKeyDown={toggleDrawer(anchor, false)}
		>
			<Button onClick={toggleDrawer(anchor, false)}><CloseIcon/></Button>
			<List>
				{['Liked Videos', 'Disliked Videos', 'Favorites'].map(
					(text, index) => (
						<ListItem button key={text}>
							<ListItemIcon>
								{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
							</ListItemIcon>
							<ListItemText primary={text} />
						</ListItem>
					)
				)}
			</List>
			<Divider />
			<List>
				{['Logout'].map((text, index) => (
					<ListItem button key={text}>
						<ListItemIcon>
							{index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
						</ListItemIcon>
						<ListItemText primary={text} />
					</ListItem>
				))}
			</List>
		</div>
	);
	const anchor: Anchor = 'left';
	return (
		<div className={classes.menuDiv}>
			{/* {(['left'] as Anchor[]).map((anchor) => ( */}
			<React.Fragment key={anchor} >
				<Drawer
					anchor={anchor}
					open={state.left}
					onClose={toggleDrawer(anchor, false)}
				>
					{list(anchor)}
				</Drawer>
			</React.Fragment>
			{/* ))} */}
		</div>
	);
}
